import { useMemo } from "react";
import { useQuery } from "@apollo/client/react";
import { type WorkflowStageRow, WorkflowStagesDataDocument } from "#app/lib/data";

const EMPTY_STAGES: WorkflowStageRow[] = [];

export function useWorkflowStagesData(workflowId: string | undefined) {
  const variables = useMemo(() => ({ workflowId: workflowId! }), [workflowId]);

  const { data, loading } = useQuery(WorkflowStagesDataDocument, {
    variables,
    skip: !workflowId,
  });

  const stages = useMemo(
    () => (data?.stages?.edges?.map((e) => e.node) as WorkflowStageRow[]) ?? EMPTY_STAGES,
    [data],
  );

  // apiv2's Workflow.name is nullable (mongo allowed missing names);
  // KanbanWorkflow expects a string, so coerce here.
  const workflows = useMemo(
    () =>
      data?.workflows?.edges?.map((e) => ({ ...e.node, name: e.node.name ?? "" })) ?? [],
    [data],
  );

  return { stages, workflows, loading };
}
